<app-admin-menu *ngIf="!isHeaderWithOnlyLang"></app-admin-menu>
<app-connection-alert *ngIf="!guest"></app-connection-alert>
<app-version-alert *ngIf="notifications.indexOf('version-alert') > -1"></app-version-alert>
<mat-toolbar
    *ngIf="isHeaderWithOnlyLang"
    class="nk3-toolbar header bar"
    color="primary"
    fxLayoutAlign="space-between center"
>
    <button [routerLink]="['/guest/start']" class="back-btn">
        <mat-icon>arrow_back_ios</mat-icon>
        <span i18n="@@back">Back</span>
    </button>
    <app-language-selector class="mr-1"></app-language-selector>
</mat-toolbar>
<ng-container *ngIf="!isHeaderWithOnlyLang">
    <mat-toolbar *ngIf="guest" class="nk3-toolbar bar" color="primary" fxLayoutAlign="space-between center">
        <ng-container *ngTemplateOutlet="logotype"></ng-container>
        <div class="contact-info">
            <span class="white" i18n="@@contactsales:">Contact sales:</span>
            <span class="red">+46 8 667 4980</span>
            <span class="white or-text" i18n="@@or">or</span>
            <a
                target="_blank"
                class="red book-meeting-btn"
                href="https://klickdata.se/kontakta-oss"
                i18n="@@bookAMeeting"
                >Book a meeting</a
            >
        </div>

        <div *ngIf="onboarding" fxLayoutAlign="center center">
            <button routerLink="/guest/login" class="login-btn" i18n="@@login">Log in</button>
            <app-language-selector></app-language-selector>
        </div>
    </mat-toolbar>
    <mat-toolbar *ngIf="!guest" class="nk3-toolbar bar w-100" color="primary" fxLayoutAlign="start center">
        <ng-container *ngTemplateOutlet="logotype"></ng-container>
        <div
            [ngStyle]="{
                width: 'calc(100% - ' + logoTypeWidth + 'px - 10px)',
                'max-width': 'calc(100% - ' + logoTypeWidth + 'px - 10px)',
                'min-width': 'calc(100% - ' + logoTypeWidth + 'px - 10px)'
            }"
            class="scroll-horizontal"
        >
            <div class="inner-menu" fxShow fxHide.lt-md="false">
                <ng-content></ng-content>
                <ng-container *appCanAccess="GeneralCapability.access(GeneralCapability.VIEW_USER_CONTENT)">
                    <app-menu-item *ngFor="let link of navbarQuickAccessData" [link]="[link.route]">
                        {{ link.label }}
                    </app-menu-item>
                </ng-container>
            </div>
            <div class="items-holder">
                <button
                    class="link-material-header-btn"
                    mat-icon-button
                    i18n-matTooltip
                    matTooltip="Help"
                    (click)="openHelp()"
                >
                    <mat-icon>help_outline</mat-icon>
                </button>

                <ng-container *appCanAccess="GeneralCapability.access(GeneralCapability.VIEW_USER_CONTENT)">
                    <button
                        *ngIf="checkResAllowedforAU() | async"
                        class="link-material-header-btn"
                        mat-icon-button
                        i18n-matTooltip
                        matTooltip="Create material"
                        (click)="addLink()"
                    >
                        <mat-icon>add_circle_outline</mat-icon>
                    </button>
                    <app-general-chat-gpt *ngIf="checkResAllowedforAU() | async"></app-general-chat-gpt>
                    <app-general-recorder
                        *ngIf="hasRecordingCapabilities() | async"
                        fxHide.lt-md="true"
                        [user]="user$ | async"
                    ></app-general-recorder>
                    <!-- <app-search></app-search> -->
                    <button
                        class="search"
                        mat-icon-button
                        i18n-matTooltip="@@search"
                        matTooltip="Search"
                        (click)="toggleSearch = !toggleSearch; this.searchService.activateSearchBox(toggleSearch)"
                    >
                        <mat-icon class="kd-icon-24">search</mat-icon>
                    </button>
                </ng-container>

                <ng-container *ngIf="authenticated | async">
                    <app-post *appCanAccess="GeneralCapability.access(GeneralCapability.VIEW_USER_CONTENT)"></app-post>

                    <ng-container *ngIf="user$ | async; let user">
                        <ng-container *ngIf="!!user.medias?.avatar && user.medias.avatar[0]; else noAvatar">
                            <app-image-view
                                class="userr-img-wrapper"
                                [matMenuTriggerFor]="profile"
                                [ngStyle]="{ minWidth: '24px' }"
                                [isCircularImg]="true"
                                [ignoreThumbnail]="true"
                                [media_id]="user.medias.avatar[0]"
                                paddingBottom="24px"
                                [showImgModalOnClick]="false"
                            >
                                <ng-container *ngIf="!!countdown" [ngTemplateOutlet]="counter"></ng-container>
                            </app-image-view>
                        </ng-container>

                        <ng-template #noAvatar>
                            <button
                                mat-icon-button
                                class="user-main-menu-img userr-img-wrapper"
                                [matMenuTriggerFor]="profile"
                                i18n-matTooltip="@@userProfileShortcut"
                                matTooltip="User Profile"
                                matTooltipShowDelay="1000"
                            >
                                <ng-container *ngIf="!!countdown" [ngTemplateOutlet]="counter"></ng-container>
                                <mat-icon class="kd-icon-24">account_circle</mat-icon>
                            </button>
                        </ng-template>
                    </ng-container>
                </ng-container>

                <!-- <app-language-selector></app-language-selector> -->
            </div>
        </div>
    </mat-toolbar>
</ng-container>
<app-main-search
    (dismissSearchArea)="toggleSearch = false; searchService.activateSearchBox(false)"
    *ngIf="isSearchBoxActive | async"
></app-main-search>
<ng-template #smallLoading>
    <app-kd-logo-loading class="small-load-header" size="small"></app-kd-logo-loading>
</ng-template>

<ng-template #counter>
    <div i18n-matTooltip matTooltip="Countdown to logout" class="count-wrap">
        <div class="num">{{ countdown }}</div>
    </div>
</ng-template>
<ng-template #logotype>
    <ng-container *ngIf="customerLanding$ | async; let customerLanding; else: smallLoading">
        <app-logotype
            [image]="customerLanding.logotype_url"
            [padding]="customerLanding.logotype_padding"
            [alt]="customerLanding.title"
            (imageLoaded)="logoTypeWidth = $event"
        ></app-logotype>
    </ng-container>
</ng-template>
<mat-menu direction="rtl" class="menu-header-options" #profile="matMenu" [overlapTrigger]="true">
    <a mat-menu-item [routerLink]="['/home/user-profile-settings']">
        <mat-icon>settings</mat-icon>
        <ng-container i18n="@@settings">Settings</ng-container>
    </a>
    <ng-container *ngIf="favouriteQuickAccess.length > 0">
        <a
            *ngFor="let favourite of favouriteQuickAccess; let first = first; let last = last"
            [routerLink]="favourite.route"
            mat-menu-item
            class="quick-access-menu-item"
            [ngClass]="{ 'first-access-item': first }"
        >
            <mat-icon>{{
                favourite.platform === 'user'
                    ? 'person'
                    : favourite.platform === 'admin'
                    ? 'people_alt'
                    : 'account_balance'
            }}</mat-icon>
            <span>{{ favourite.label }}</span>
        </a>
    </ng-container>
    <a
        *ngIf="
            enabledQuickAccess.user.length > 0 ||
            enabledQuickAccess.admin.length > 0 ||
            enabledQuickAccess.master.length > 0
        "
        mat-menu-item
        class="quick-access-menu-item last-access-item"
        [matMenuTriggerFor]="quickAccess"
        [ngClass]="{ 'no-border-bottom': !favouriteQuickAccess.length }"
        (click)="openQuickAccessAUSettings()"
    >
        <mat-icon>switch_access_shortcut</mat-icon>
        <ng-container *ngIf="favouriteQuickAccess.length > 0" i18n>More</ng-container>
        <ng-container *ngIf="!favouriteQuickAccess.length" i18n>Quick Access</ng-container>
    </a>

    <a
        mat-menu-item
        *ngIf="!enabledQuickAccess.user.length && !enabledQuickAccess.admin.length && !enabledQuickAccess.master.length"
        class="quick-access-menu-item"
        (click)="openQuickAccessAUSettings()"
    >
        <mat-icon>switch_access_shortcut</mat-icon>
        <ng-container i18n>Quick Access</ng-container>
    </a>
    <!-- <ng-container *ngIf="navbarQuickAccessData.length < 3"> -->
    <ng-container *ngIf="user$ | async; let authUser">
        <ng-container *ngIf="customer$ | async; let customer">
            <a mat-menu-item (click)="addNavbarQuickAccess(authUser, customer)">
                <mat-icon>format_list_bulleted</mat-icon>
                <ng-container i18n="@@addToNavbar">Add to navbar</ng-container>
            </a>
        </ng-container>
    </ng-container>
    <!-- </ng-container> -->
    <mat-menu xPosition="before" class="quick-access-menu" #quickAccess="matMenu">
        <ng-container *ngIf="user$ | async; let authUser">
            <a *ngIf="enabledQuickAccess.user.length > 0" mat-menu-item [matMenuTriggerFor]="user">
                <mat-icon>person</mat-icon>
                <span>User</span>
            </a>
            <a
                *ngIf="enabledQuickAccess.admin.length > 0 && authUser.isAdmin()"
                mat-menu-item
                [matMenuTriggerFor]="admin"
            >
                <mat-icon>people_alt</mat-icon>
                <span>Admin</span>
            </a>
            <a
                *ngIf="enabledQuickAccess.master.length > 0 && authUser.isMasterAdmin()"
                mat-menu-item
                [matMenuTriggerFor]="master"
            >
                <mat-icon>account_balance</mat-icon>
                <span>Master</span>
            </a>
        </ng-container>
    </mat-menu>
    <mat-menu xPosition="before" class="menu-header-options" #user="matMenu" [overlapTrigger]="false">
        <a *ngFor="let link of enabledQuickAccess.user" mat-menu-item [routerLink]="link.route">
            <span>{{ link.label }}</span>
        </a>
    </mat-menu>
    <mat-menu xPosition="before" class="menu-header-options" #admin="matMenu" [overlapTrigger]="false">
        <a *ngFor="let link of enabledQuickAccess.admin" mat-menu-item [routerLink]="link.route">
            <span>{{ link.label }}</span>
        </a>
    </mat-menu>
    <mat-menu xPosition="before" class="menu-header-options" #master="matMenu" [overlapTrigger]="false">
        <a *ngFor="let link of enabledQuickAccess.master" mat-menu-item [routerLink]="link.route">
            <span>{{ link.label }}</span>
        </a>
    </mat-menu>

    <a mat-menu-item (click)="reset()">
        <mat-icon>autorenew</mat-icon>
        <ng-container i18n>Reload</ng-container>
    </a>
    <a mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <ng-container i18n>Logout</ng-container>
    </a>
    <a [routerLink]="['/changelog']" class="version" mat-menu-item>
        <ng-container *ngIf="version$ | async; let ver">
            {{ ver.version.slice(0, ver.version.lastIndexOf('-')) }} - {{ ver.date | date : 'MMM d HH.mm' }} GMT
        </ng-container>
    </a>
</mat-menu>
